import { render, staticRenderFns } from "./FilmModal.vue?vue&type=template&id=fcd95292&scoped=true&"
import script from "./FilmModal.vue?vue&type=script&lang=ts&"
export * from "./FilmModal.vue?vue&type=script&lang=ts&"
import style0 from "./FilmModal.vue?vue&type=style&index=0&id=fcd95292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd95292",
  null
  
)

export default component.exports